import type { IDashboardRepository } from '@/core/domain/dashboard/IDashboardRepository'
import type { DashboardClassroomDiagnosticTrigger } from '@/core/domain/dashboard/DashboardClassroomDiagnosticTrigger'

/**
 * Use case pour récupérer les diagnostics d'une classe
 */
export class FetchClassroomDiagnosticsUseCase {
  private dashboardRepository: IDashboardRepository

  constructor(dashboardRepository: IDashboardRepository) {
    this.dashboardRepository = dashboardRepository
  }

  async execute(classroomId: number): Promise<DashboardClassroomDiagnosticTrigger[]> {
    return await this.dashboardRepository.fetchAllDashboardClassroomDiagnosticTriggersByClassroomId(
      classroomId
    )
  }
}
